import type { StateCreator } from 'zustand';

/**
 * Тип функции для получения токена доступа
 * Устанавливается AuthBootstrap при инициализации MSAL
 */
type AccessTokenProvider = () => Promise<string | null>;

/**
 * Auth Slice - управление токеном авторизации
 * 
 * ВАЖНО: Токен НЕ сохраняется в localStorage/sessionStorage.
 * При обновлении страницы токен получается заново от MSAL.
 */
export interface AuthSlice {
  /** Функция для получения токена (устанавливается из AuthBootstrap) */
  getAccessToken: AccessTokenProvider | null;
  /** Устанавливает провайдер токена */
  setAccessTokenProvider: (fn: AccessTokenProvider) => void;
  /** Сбрасывает провайдер токена (при выходе) */
  clearAccessTokenProvider: () => void;
}

/**
 * Создание Auth Slice с использованием StateCreator
 * 
 * @example
 * ```tsx
 * // В AuthBootstrap - установка провайдера
 * useAppStore.getState().setAccessTokenProvider(async () => {
 *   return await getAccessToken();
 * });
 * 
 * // В API клиенте - получение токена
 * const token = await useAppStore.getState().getAccessToken?.();
 * ```
 */
export const createAuthSlice: StateCreator<
  AuthSlice,
  [],
  [],
  AuthSlice
> = (set) => ({
  getAccessToken: null,
  
  setAccessTokenProvider: (fn) => {
    set({ getAccessToken: fn });
    if (import.meta.env.DEV) {
      console.log('✅ AuthStore: Токен-провайдер установлен');
    }
  },
  
  clearAccessTokenProvider: () => {
    set({ getAccessToken: null });
    if (import.meta.env.DEV) {
      console.log('🔒 AuthStore: Токен-провайдер очищен');
    }
  },
});


